<template>
  <div>
    <!-- 날짜 -->
    <div class="absolute top-0 flex items-center gap-4" :class="[!isPrint && 'py-6']" style="left: calc(180px + 1.5rem)">
      <div class="flex items-center justify-center gap-3">
        <p v-if="isPrint" class="print-input">{{ form.headerYear | moment("YYYY") }}</p>
        <input v-else type="number" :readonly="board.readonly || isPostId" min="1800" max="9999" v-model="form.headerYear" style="width: 100px" />{{ $t('년') }}<p v-if="isPrint" class="print-input">{{ form.headerMonth | moment("MM") }}</p>
        <input v-else type="number" :readonly="board.readonly || isPostId" min="1" max="12" v-model="form.headerMonth" style="width: 100px" @input="formatMonth"/>{{ $t('월') }}</div>
    </div>

    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="fieldTypes"
      :typeslabel="{
        date: '최초 작성일',
        updated_at: '최종 수정일',
      }"
    />

    <div>
      <!-- TitleCheckBox -->
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-2 flex items-center" v-for="productTitle in productTitles" v-bind:key="productTitle">
          <div v-if="isPrint || board.readonly || readonlyYear" class="flex items-center justify-center">
            <div v-if="form.checkProductTitles.includes(productTitle)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            {{ productTitle }}
          </div>
          <label v-else class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="form.checkProductTitles" :vs-value="productTitle">{{ productTitle }}</vs-checkbox>
          </label>
        </div>
      </div>

      <!-- Table -->
      <table-product-check
        v-for="(product, product_i) in productTitles"
        :key="`table_${product}`"
        v-show="form.checkProductTitles.includes(product)"
        :isPrint="isPrint"
        :readonly="board.readonly || readonlyYear"
        :title="product"
        v-model="form[`productList${product_i + 1}`]"
        class="mt-5"
      />

      <!-- 확인자 -->
      <div>
        <vs-row class="my-4">
          <h5 style="align-self: center"><i class="dot"></i>{{ $t('확인자') }}</h5>
          <div class="ml-auto">
            <vs-button v-if="!isPrint && !board.readonly && !readonlyYear" class="" color="secondary" type="border" @click="handleAddRow">{{ $t('항목추가') }}</vs-button>
            <vs-button v-if="!isPrint && !board.readonly && !readonlyYear" class="ml-4" color="secondary" @click="handleRemoveRow">{{ $t('항목삭제') }}</vs-button>
          </div>
        </vs-row>
        <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4" v-for="(row, index) in form.checker" :key="index">
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('소속명') }}</div>
            <p v-if="isPrint" class="print-input flex-1">{{ row.department }}</p>
            <ml-input v-else :readonly="board.readonly || readonlyYear || row.readonly" v-model="row.department" class="w-full flex-1"/>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('부서명') }}</div>
            <p v-if="isPrint" class="print-input flex-1">{{ row.section }}</p>
            <ml-input v-else :readonly="board.readonly || readonlyYear || row.readonly" v-model="row.section" class="w-full flex-1"/>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">{{ $t('성명') }}</div>
            <p v-if="isPrint" class="print-input flex-1">{{ row.name }}</p>
            <ml-input v-else :readonly="board.readonly || readonlyYear || row.readonly" v-model="row.name" class="w-full flex-1"/>
          </div>
        </div>
      </div>

      <!-- 파일첨부 -->
      <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
    </div>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableProductCheck from "@/components/TableProductCheck.vue";
import moment from "moment";

export default {
  components: {
    TableProductCheck,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      readonlyYear: false,
      productTitles: ["의료기기", "전자제품", "기타"],
      form: {
        headerYear: moment(new Date()).format("YYYY"),
        headerMonth: moment(new Date()).format("MM"),
        headerDate: '',
        headerDateString: '',
        stdInfo: {},
        checkProductTitles: [],
        productList1: [],
        productList2: [],
        productList3: [],
        checker: [],
        fileList: [],
      },
    };
  },
  computed: {
    fieldTypes() {
      return ["field_name", "department", "com_name", "rank", "writer_name", "date", "updated_at"];
    },
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    'form.headerYear' : {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerDate = `${this.form.headerYear}-${this.form.headerMonth}-01`
        this.form.headerDateString = `${this.form.headerYear}년 ${this.form.headerMonth}월`
      }
    },
    'form.headerMonth' : {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerDate = `${this.form.headerYear}-${this.form.headerMonth}-01`
        this.form.headerDateString =  `${this.form.headerYear}년 ${this.form.headerMonth}월`
      }
    },
  },
  methods: {
    handleAddRow() {
      this.form.checker.push({
        department: "",
        section: "",
        name: "",
      });
    },
    // 선택삭제
    handleRemoveRow() {
      if (0 < this.form.checker.length && !this.form.checker[this.form.checker.length - 1].readonly) this.form.checker.splice(this.form.checker.length - 1);
    },
    formatMonth() {
      this.form.headerMonth = String(this.form.headerMonth).padStart(2, '0');
    }
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

input[type="number"] {
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.7rem !important;
  transition: all 0.3s ease;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
